import type { ReactNode } from 'react';
import { useLongPress } from '@/shared/hooks/useLongPress';

export function ProductLongPressTarget({ children, enabled, productName, onOpen }: {
  children: ReactNode;
  enabled: boolean;
  productName: string;
  onOpen: () => void;
}) {
  const handlers = useLongPress<HTMLDivElement>(onOpen, { enabled });
  return <div className="h-full" style={enabled ? { WebkitTouchCallout: 'none' } : undefined} {...handlers} onPointerDown={event => {
    const target = event.target as HTMLElement;
    const button = target.closest('button');
    // Product-image buttons participate; wishlist/video/cart/similar actions do not.
    if (button && button.getAttribute('aria-label') !== productName) return;
    handlers.onPointerDown(event);
  }}>{children}</div>;
}
